
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Innovacrystaonrentinpune() {



    const cardData =
    {
        keyword: 'Innova Crysta on Rent in Pune',
        heading: 'Mauli Cabs: Innova Crysta on Rent in Pune',
        headingDescription: 'Mauli Cabs offers Innova Crysta on rent in Pune, providing a comfortable and spacious travel experience for families, groups, and business travelers. Whether you need it for a day trip, wedding, corporate event, or long-distance travel, our well-maintained Innova Crysta vehicles offer ample legroom, premium interiors, and a smooth ride. With professional drivers, flexible rental durations, transparent pricing, and no hidden charges, Mauli Cabs ensures a hassle-free and enjoyable journey.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located about 30 km from Pune, Sinhagad Fort is a favorite spot for trekking and offers panoramic views and a rich historical background."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganesh temples in Maharashtra, this temple is revered for its magnificent idol and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Parvati Hill",
        "description": "Parvati Hill offers a serene temple complex atop a hill with beautiful views of the city and is one of the oldest heritage sites in Pune."
    },
    {
        "title": "Osho Garden and Ashram",
        "description": "Located in Koregaon Park, this peaceful garden and spiritual center draws global visitors for meditation and relaxation in tranquil surroundings."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum showcases a fascinating collection of artifacts, including musical instruments, weaponry, and antiques, celebrating India’s cultural heritage."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by a Japanese design, this beautifully landscaped garden is perfect for calm walks and nature photography."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Also known as Katraj Zoo, this park houses various species of animals and a dedicated snake park, popular with families and kids."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, this ancient monument offers spiritual solace in the middle of the city."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Travel in comfort with a spacious Innova cab from Pune to Mumbai. Ideal for families, groups, or business trips, enjoy a smooth ride with experienced drivers and reliable service."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova",
      "description": "Book a comfortable Innova for a seamless airport drop from Pune to Mumbai. Enjoy timely pickups and a smooth ride to the airport in a spacious and luxurious vehicle."
    },
    {
      "name": "Mumbai Airport to Pune Innova",
      "description": "Get picked up from Mumbai Airport in a premium Innova cab for your journey to Pune. With professional drivers and on-time service, enjoy a hassle-free ride to your destination."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Rent an Innova for your Mumbai to Pune trip. Enjoy a flexible rental service with a variety of options, perfect for family trips, corporate travel, and more."
    },
    {
      "name": "Pune to Mumbai Airport Innova",
      "description": "Book an Innova cab for a hassle-free ride from Pune to Mumbai Airport. Experience comfortable and timely service with professional drivers and luxury vehicles."
    },
    {
      "name": "Innova Crysta on Rent in Pune Airport",
      "description": "Rent an Innova Crysta directly from Pune Airport for a comfortable, premium travel experience. Ideal for long-distance travel, group trips, or corporate travel."
    },
    {
      "name": "Innova Per Km Rate in Pune",
      "description": "Get transparent pricing for Innova cabs in Pune with per-km rates. Enjoy a cost-effective and comfortable ride with no hidden charges."
    },
    {
      "name": "Pune to Andheri Innova Crysta",
      "description": "Book an Innova Crysta for a premium ride from Pune to Andheri. Ideal for business or leisure, experience comfort, space, and reliability throughout your journey."
    },
    {
      "name": "Pune to Mumbai Innova Crysta",
      "description": "Travel in luxury from Pune to Mumbai in an Innova Crysta. Enjoy a spacious, comfortable ride with a professional driver and flexible scheduling options."
    },
    {
      "name": "Pune to Mumbai Oneway Innova Crysta",
      "description": "Book a one-way ride from Pune to Mumbai in an Innova Crysta. Ideal for solo or group travelers, enjoy a safe, comfortable, and direct journey."
    },
    {
      "name": "Pune to Mumbai Innova",
      "description": "Choose our Innova for a premium ride from Pune to Mumbai. Perfect for families and business trips, with ample space, comfort, and experienced drivers."
    },
    {
      "name": "Pune Airport to Mumbai Airport Innova Cab",
      "description": "Book an Innova for a smooth ride between Pune and Mumbai airports. Enjoy comfortable seating and reliable service for your airport-to-airport transfer."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Innova Cab", "Pune to Mumbai Airport Drop Innova"],
    ["Mumbai Airport to Pune Innova", "Pune Mumbai Innova Rental"],
    ["Pune to Mumbai Airport Innova", "Innova Crysta on Rent in Pune Airport"],
    ["Innova Per Km Rate in Pune", "Pune to Andheri Innova Crysta"],
    ["Pune to Mumbai Innova Crysta", "Pune to Mumbai Oneway Innova Crysta"],
    ["Pune to Mumbai Innova", "Pune Airport to Mumbai Airport Innova Cab"],
    ["", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta on Rent in Pune",
        "WhyChoosedescription": "Mauli Cabs offers the luxurious and spacious Innova Crysta on rent in Pune for all your travel needs. Whether it’s for a family trip, corporate travel, or group outing, enjoy a premium ride with unmatched comfort."
    },
    {
        "WhyChooseheading": "Comfort and Luxury for Every Journey",
        "WhyChoosedescription": "The Innova Crysta is known for its comfort, ample legroom, and smooth ride. With air-conditioning, plush interiors, and ample space for luggage, it's perfect for long-distance travel, airport pickups, or group trips."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Safe Ride",
        "WhyChoosedescription": "Our professional drivers are highly experienced and ensure your safety and comfort throughout your journey. With in-depth knowledge of Pune’s roads, they provide a smooth, timely, and hassle-free experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for renting an Innova Crysta in Pune, with no hidden charges. Enjoy a luxurious ride without breaking the bank—what you see is what you pay."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "We operate round the clock to cater to your travel needs. Whether you need an Innova Crysta for a day trip, corporate event, or late-night airport transfer, we’re available anytime you need us."
    },
    {
        "WhyChooseheading": "Instant Booking and Real-Time Tracking",
        "WhyChoosedescription": "Booking your Innova Crysta on rent is easy with Mauli Cabs. Simply book online or through our app and track your ride in real-time for added convenience and peace of mind."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Ride",
        "WhyChoosedescription": "We prioritize your safety. Our Innova Crysta vehicles are regularly sanitized, and our drivers follow strict hygiene and safety protocols to ensure a secure and comfortable journey."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "We offer multiple payment methods, including UPI, credit/debit cards, mobile wallets, and cash. Pay the way that works best for you, with a smooth and secure transaction process."
    }
]















    }

    const faqData = [
        {
            question: 'How can I rent an Innova Crysta in Pune with Mauli Cabs?',
            answer: 'Renting an Innova Crysta in Pune with Mauli Cabs is easy. Simply visit our website or app, select "Innova Crysta" from the vehicle options, choose your rental duration, and confirm your booking. Our team is available for assistance anytime through customer support.',
        },
        {
            question: 'What is the rental duration for Innova Crysta in Pune?',
            answer: 'Mauli Cabs offers flexible rental durations for Innova Crysta, ranging from hourly rentals to daily or even long-term bookings. You can choose the option that best suits your needs.',
        },
        {
            question: 'Is the rental price for Innova Crysta in Pune fixed?',
            answer: 'Yes, the rental price for the Innova Crysta in Pune is fixed. The price includes driver charges, fuel, taxes, and tolls (for local rentals). For long-distance trips, additional charges may apply.',
        },
        {
            question: 'Can I book an Innova Crysta on rent for a one-way trip?',
            answer: 'Yes, Mauli Cabs offers one-way rentals for the Innova Crysta. You can book it for a one-way trip to destinations like Mumbai, Lonavala, or other nearby locations.',
        },
        {
            question: 'Is the Innova Crysta rental service available 24/7 in Pune?',
            answer: 'Yes, the Innova Crysta rental service is available 24/7 in Pune. Whether you need a ride for a late-night journey or an early morning pickup, Mauli Cabs has got you covered.',
        },
        {
            question: 'What are the benefits of renting an Innova Crysta in Pune?',
            answer: 'Renting an Innova Crysta gives you the benefit of a comfortable, spacious, and luxurious ride with ample legroom and storage space. It’s ideal for long journeys, family trips, business travel, or group outings.',
        },
        {
            question: 'Can I carry extra luggage in the rented Innova Crysta?',
            answer: 'Yes, the Innova Crysta offers plenty of luggage space. If you have extra or bulky luggage, it’s the perfect vehicle choice for a comfortable journey.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Anil Soni",
            position: "Business Owner",
            text: "I rented an Innova Crysta for a business trip in Pune. The vehicle was clean, comfortable, and well-maintained. The driver was professional, and the overall experience was smooth. Highly recommend Mauli Cabs for anyone looking for reliable rental services!",
            image: "/img/testimonial/testimonial-thumb-1-91.png",
        },
        {
            name: "Ms. Preeti Deshmukh",
            position: "Event Planner",
            text: "I rented an Innova Crysta for a family outing in Pune. The ride was luxurious and spacious, making our trip enjoyable. The booking process was easy, and the vehicle was exactly as described. Great service from Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-92.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Innova Crysta on Rent in Pune",
        "description": "Rent the luxurious Innova Crysta for a comfortable journey from Pune to Mumbai and back. Enjoy a seamless travel experience with competitive pricing.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "1500"
        }
      };
      

   


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Innova Crysta on Rent in Pune | Luxury Car Rental</title>
        <meta
          name="description"
          content="Rent the Innova Crysta in Pune for your travel needs. Book a comfortable, reliable, and affordable taxi from Pune to Mumbai and other destinations."
        />
        <meta
          name="keywords"
          content="Pune to Mumbai Innova cab, Pune to Mumbai airport drop Innova, Mumbai airport to Pune Innova, Pune Mumbai Innova rental, Pune to Andheri Innova Crysta, Pune to Mumbai Innova Crysta, Pune to Mumbai one-way Innova Crysta, Innova per km rate in Pune, Pune airport to Mumbai airport Innova cab"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/129.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Innovacrystaonrentinpune;